import { useContext, useEffect } from "react"
import { AppContext } from "../../context/AppContext";
import { MapContext } from "../../context/MapContext"
import { outflowBgLayers, outflowLayers } from "./layers";
import { Style, Fill } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import InoutflowLegend from "../legend/InoutflowLegend";
import BottomBox from "../bottomBox/BottomBox";
import { abstractFetch } from "../../common/func/abstractFetch";
import { cql2filter } from "../../common/func/cql2filter";

export default function OutflowMap() {
  const {step, mapMode, setBackdropOpen} = useContext(AppContext);
  const { outLegendControlOpen, setOutLegendControlOpen,
          outCollapseBgMap, setOutCollapseBgMap,
          outHubGridOpacity, setOutHubGridOpacity,
          outflowBgMap, setOutflowBgMap,
          outflowIndex, setOutflowIndex,
          outflowIndexInput,
          zoomLevel,
          createMap,
          handleOutflowIndexInput,
          outflowMapRef
        } = useContext(MapContext);

  const handleOutflowView = (type) => {
    const value = type === 'plus' ? 1 : -1;
    outflowMapRef.current
      .getView()
      .setZoom(outflowMapRef.current.getView().getZoom() + value);
  };

  const pointerOutHubFeature = (e) => {
		outflowMapRef.current.forEachFeatureAtPixel(
			e.pixel,
			outPointerMoveCallBack
		);
	};

  let outSelected = null;
	const outPointerMoveCallBack = (selectedFeature, layer) => {
		if (layer.get('title') === '출입 중심거점') {
			outSelected = selectedFeature;
			const outFlowSelectFeatureColor = new Style({
				// fill: new Fill({ color: '#1aa7ec', opacity: '1' }),
				fill: new Fill({ color: '#FA874F', opacity: '1' }),
			});
			selectedFeature.setStyle(outFlowSelectFeatureColor);
			return true;
		} else {
		}
	};

  // 최초 렌더링
	useEffect(() => {
		setBackdropOpen(true);
		
    outflowMapRef.current = createMap(
			'outMap',
			Object.keys(outflowBgLayers).map((key) => outflowBgLayers[key]),
			Object.keys(outflowLayers).map((key) => outflowLayers[key])
		)

		outflowMapRef.current.on('pointermove', (e) => {
			if (outSelected !== null) {
				outSelected.setStyle(undefined);
				outSelected = null;
			}
			pointerOutHubFeature(e);
		});

		const fetchXmlString = async (outflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_out_val>=' + outflowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
				.then((res) => {
					outflowLayers.centralHubV.getSource().clear();
					outflowLayers.centralHubV
						.getSource()
						.addFeatures(new GeoJSON().readFeatures(res));

						
						setBackdropOpen(false);
			});

			const outMapZoom = outflowMapRef.current.getView().getZoom();
			
			if (outMapZoom <= 11) {
				outflowLayers.centralHubT
					.getSource()
					.updateParams({ filter: await cql2filter(`pc_out_val>=${outflowIndex}`) });
				outflowLayers.centralHubT.getSource().refresh();
			}
		}
		fetchXmlString(outflowIndex);
	}, []);

  useEffect(() => {
		setOutflowIndex(outflowIndexInput);
	}, [outflowIndexInput]);

  useEffect(() => {
		const fetchXmlString = async (outflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_out_val>=' + outflowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
			.then((res) => {
				outflowLayers.centralHubV.getSource().clear();
				outflowLayers.centralHubV
					.getSource()
					.addFeatures(new GeoJSON().readFeatures(res));
			});

			outflowLayers.centralHubT
				.getSource()
				.updateParams({ filter: await cql2filter(`pc_out_val>=${outflowIndex}`) });
			outflowLayers.centralHubT.getSource().refresh();
		}
		fetchXmlString(outflowIndex);
	}, [step]);


  return (
    <div
					className={
						mapMode === 'dual'
							? 'partition'
							: mapMode === 'out'
							? 'partition--single'
							: 'partition--invisible'
					}
				>
					<InoutflowLegend 
            step={1}
						legendControlOpen={outLegendControlOpen}
						setLegendControlOpen={setOutLegendControlOpen}
						collapseBgMap={outCollapseBgMap}
						setCollapseBgMap={setOutCollapseBgMap}
						hubGridOpacity={outHubGridOpacity}
						setHubGridOpacity={setOutHubGridOpacity}
						flowBgMap={outflowBgMap}
						setFlowBgMap={setOutflowBgMap}
            bgLayers={outflowBgLayers}
						flowLayers={outflowLayers}
						target={{
							cssName: 'right',
							color: 'blueBox',
							name: '유출',
							flowHub: 'outflowHub',
						}}
					/>

					<div id="outMap" className="mapArea" />
					<div className="mapZoom">
						<button onClick={() => handleOutflowView('plus')}>
							<img src="img/zoomPlus.png" alt="확대" />
						</button>
						<button onClick={() => handleOutflowView('minus')}>
							<img src="img/zoomMin.png" alt="축소" />
						</button>
					</div>

					<div className="mapTit blueBG">유출 중심 거점</div>

					{/* {zoomLevel < 11 ? ( */}
					<div className="zoomTooltip">
						{zoomLevel < 9
							? '화면을 확대하면 격자의 정보를 볼 수 있습니다.'
							: '격자를 클릭하면 해당 격자의 정보를 확인할 수 있습니다.'}
					</div>
					{/* ) : null} */}
					<BottomBox
            max={16.054}
            flowIndex={outflowIndex}
            flowIndexInput={outflowIndexInput}
            handleFlowIndexInput={handleOutflowIndexInput}
            flowLayers={outflowLayers}
            target={{
              mapMode1: 'out',
              mapMode2: 'in',
              name: '유출',
              max1: '16.054',
              base: '0.03은',
              average: '0.20443',
              medium: '0.00727',
              max2: '16.05416',
              textColor: 'blueText',
              colorBox: 'blueBox',
            }}
          />
				</div>
  )
}